import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import analysts_Architect_INTJ_personality_header from '../../images/personality_types_details/analysts_Architect_INTJ_personality_header.svg'
import analysts_Architect_INTJ_career_path from '../../images/personality_types_details/analysts_Architect_INTJ_career_path.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const intj_careers = () => {
    return (
        <Layout>
            <main className="q-td analyst architect">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/architect-intj-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-careers" className="tab with-progress active">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intjs-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header className="type-header analyst architect">
                    <svg className="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path className="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path className="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>
                    <img src={analysts_Architect_INTJ_personality_header} className="scene" alt='loading...' />
                    <div className="type-info">
                        <h1><span>Architect</span> Personality</h1>
                        <div className="code">INTJ-A / INTJ-T</div>
                        <a href="#" className="difference">(What’s the difference?)</a>
                    </div>
                </header>


                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/architect-intj-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-parents">Parenthood</Link></li>
                                <li className="active"><Link to="/personality-types/architect-intj-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/architect-intjs-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>    Career Paths
</h1>


                        <blockquote><p>“One never notices what has been done; one can only see what remains to be done, and if one didn’t like the work, it would be very discouraging.”</p> <footer>MARIE CURIE</footer></blockquote>

                        <p>Professional know-how is often where Architects (INTJs) shine most brilliantly. But these personalities won’t settle for just any career. They want to tackle meaningful challenges and find elegant solutions to important problems, not just tinker with figures in a spreadsheet.</p>

                        <p>Architects also want the freedom to exercise their greatest strengths. Few personality types, if any, can match their ability to transform complex principles into clear and actionable strategies. Architects know how much they have to offer in their professional lives – and for them, any job that fails to draw on their skills and knowledge is a wasted opportunity.</p>

                        <div class="scene"><img alt="Architect (INTJ) careers" src={analysts_Architect_INTJ_career_path} /></div>

                        <h2>The Early-Career Blues</h2>

                        <p>Starting out at the bottom of the career ladder can be frustrating for Architects. Early in their professional lives, they may be saddled with easy, routine tasks that bore them half to death. People with this personality type brim with creative, out-of-the-box ideas. But with their disdain for schmoozing and workplace politics, they may struggle to earn the favor of their bosses and colleagues.</p>

                        <p>The good news is that, over time, Architects can develop their abilities into a track record so effective that it can’t be ignored. Even when the people around them fall prey to groupthink, Architect personalities can cut through the noise and figure out the true cause of a problem – and then fix it. Their competence gives them an advantage. As long as they don’t alienate their coworkers, Architects can advance in their careers and gain the independence they need to see their ideas through.</p>

                        <h2>Finding Their Place</h2>

                        <p>Some personality types are drawn to jobs that require nonstop teamwork and interaction, but Architects tend to prefer lone-wolf positions. By working alone or in small groups, they can make the most of their creativity without constant interruptions from curious coworkers or second-guessing supervisors. Architects really do believe that if you want something done right, you’d better do it yourself.</p>

                        <p>The other side of that coin is that Architects have little respect for anyone who gets ahead based on networking or nepotism rather than merit. People with this personality type value resourcefulness, grit, insight, and commitment – in themselves and in others. They believe that everyone should get their work done to the highest possible standards. So if a social butterfly at work breezes through without carrying their own weight, Architects may feel called to use their ingenuity to bring that person back down to earth.</p>

                        <h2>Ever Greater Challenges</h2>

                        <p>Architect personality types demand progress and evolution, and they love to explore new ideas. As their careers progress, they may be drawn to positions that allow them to influence a company or organization’s overall strategies. Many Architects pursue low-profile but influential roles as project managers, systems engineers, marketing strategists, systems analysts, and military strategists.</p>

                        <div class="description-pullout">
                            Architects view a combination of intelligent approaches and hard work as the road to excellence.
</div>

                        <p>The truth is that Architects can excel in just about any role. Some careers with strong social components, such as sales or human resources, might not seem like obvious fits – but fortunately, Architects know how to look beyond the obvious. These personalities have the creativity and vision to make important contributions in any workplace, and these skills certainly give them a leg up if they choose to start their own business.</p>

                        <div class="number">06</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/architect-intj-parents' className='next-feature'>
                            Parenthood
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/architect-intjs-at-work' className='next-feature'>
                            Workplace Habits
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default intj_careers
